import { render, staticRenderFns } from "./ServiceRequest.vue?vue&type=template&id=8bd16fbe&scoped=true&"
import script from "./ServiceRequest.vue?vue&type=script&lang=js&"
export * from "./ServiceRequest.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequest.vue?vue&type=style&index=0&id=8bd16fbe&scoped=true&lang=css&"
import style1 from "./ServiceRequest.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd16fbe",
  null
  
)

export default component.exports